import { render, staticRenderFns } from "./identification_base.vue?vue&type=template&id=69a536c8&scoped=true"
import script from "./identification_base.vue?vue&type=script&lang=js"
export * from "./identification_base.vue?vue&type=script&lang=js"
import style0 from "./identification_base.vue?vue&type=style&index=0&id=69a536c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a536c8",
  null
  
)

export default component.exports